'use strict';

var UserFbcExclusionRulesTransformerFactory = function UserFbcExclusionRulesTransformerFactory(DataTransformer, momentService) {
  function UserFbcExclusionRulesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-fbc-exclusion-rules-mode';
  }
  UserFbcExclusionRulesTransformer.prototype = Object.create(DataTransformer.prototype);
  UserFbcExclusionRulesTransformer.constructor = UserFbcExclusionRulesTransformer;
  UserFbcExclusionRulesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserFbcExclusionRulesTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserFbcExclusionRulesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserFbcExclusionRulesTransformer.prototype.transform = function (data) {
    var exclusionRules = data.domain.results;
    var result = [];
    for (var i = 0; i < exclusionRules.length; i++) {
      var exclusionRule = exclusionRules[i];
      var exclusion = {
        originAirport: transformFromAsterisk(exclusionRule.origin),
        destinationAirport: transformFromAsterisk(exclusionRule.destination),
        fareClass: transformFromAsterisk(exclusionRule.fareClass),
        fbcPattern: exclusionRule.fbcPattern,
        lastUpdatedDate: momentService.of(exclusionRule.lastUpdatedDate, momentService.FIELD.LAST_UPDATED_AT),
        lastUpdatedBy: exclusionRule.lastUpdatedBy
      };
      result.push(exclusion);
    }
    return result;
  };
  function transformFromAsterisk(field) {
    return field === '*' ? 'All' : field;
  }
  return UserFbcExclusionRulesTransformer;
};
UserFbcExclusionRulesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = UserFbcExclusionRulesTransformerFactory;